import { gql } from '@apollo/client';
import { BASE_PARTNER_COMPANY_FRAGMENT } from './partner.fragments';
import { FARM_SITE_FRAGMENT, SITE_CLUSTER_FRAGMENT } from './site.fragments';

export const BASE_GEO_DATA = gql`
  fragment baseGeoDataValues on GeoData {
    id
    createdTimestamp
    modifiedTimestamp
    createdById
    dataType
    title
    rawMaterial {
      id
      title
      hsCodes {
        id
        code
        description
      }
      eudrMaterialType
    }
    originCountry
    ownedBy {
      ...basePartnerCompanyValues
    }
    totalPlotsArea
    datasetId
    siteClusterId
    status
    issuesCount
    riskStatus
    createdBy {
      ...basePartnerCompanyValues
    }
  }
  ${BASE_PARTNER_COMPANY_FRAGMENT}
`;

export const GEOC_BATCH = gql`
  fragment geocBatchValues on GeocBatch {
    id
    createdTimestamp
    modifiedTimestamp
    externalBatchId
    geocBatchId
    weight
    riskStatus
    checkDate
    geoDataProcessId
  }
`;

export const GEO_DATA_ISSUE = gql`
  fragment geoDataIssueValues on GeoDataIssue {
    geoDataId
    siteId
    entityId
    entityType
    errorCategory
    errorMessage
    errorAdditionalInfo
  }
`;

export const GEO_DATA_FRAGMENT = gql`
  fragment geoDataValues on GeoData {
    ...baseGeoDataValues
    geocBatches {
      ...geocBatchValues
    }
    dataset {
      id
      createdTimestamp
      modifiedTimestamp
      createdById
      title
      originCountry
      rawMaterial {
        id
        title
      }
      ownedBy {
        ...basePartnerCompanyValues
      }
      status
      issues {
        ...geoDataIssueValues
      }
      riskStatus
      originalGeoDataId
    }
    siteCluster {
      ...siteClusterValues
    }
    sites(first: 3) {
      count
      edges {
        node {
          ...farmSiteValues
        }
      }
    }
    issues {
      ...geoDataIssueValues
    }
    excludedSitesIds
    siteSelectionId
    totalOriginalSiteCount
  }
  ${GEOC_BATCH}
  ${BASE_GEO_DATA}
  ${BASE_PARTNER_COMPANY_FRAGMENT}
  ${SITE_CLUSTER_FRAGMENT}
  ${FARM_SITE_FRAGMENT}
  ${GEO_DATA_ISSUE}
`;
